module.exports = __webpack_public_path__ + "static/media/admin_plugin_server.adb79652.svg";